import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppLocationDialogComponent } from './app-location-dialog/app-location-dialog.component';
import { DialogComponent } from './dialog/dialog.component';
import { ExchangeRateComponent } from './exchange-rate/exchange-rate.component';
import { EternalLinkDialogComponent } from './external-link-dialogs/external-link-dialog.component';
import { IndicativeRateNoteComponent } from './indicative-rate-note/indicative-rate-note.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { MoneygramLocationsLinkComponent } from './moneygram-locations-link/moneygram-locations-link.component';
import { PartnerWalletBannerComponent } from './partner-wallet-banner/partner-wallet-banner.component';
import { StatusUpdatesComponent } from './status-updates/status-updates.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { WalmartFootnoteComponent } from './walmart-footnote/walmart-footnote.component';
import { BaseComponent } from './base.component';
import { CardCustomerSupportComponent } from './card-customer-support/card-customer-support.component';
import { DemoMaterialModule } from '../material.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { LocatorModule } from '../locator/locator.module';
import { MobilePhoneNumberComponent } from './mobile-phone-number/mobile-phone-number.component';
import { DialogLocationMapComponent } from './dialog-location-map/dialog-location-map.component';
import { AlertLocationComponent } from './dialog/alert-location/alert-location.component';
import { PoweredByStellarComponent } from './powered-by-stellar/powered-by-stellar.component';

const SHARED_COMPONENTS = [
  AppLocationDialogComponent,
  CardCustomerSupportComponent,
  DialogComponent,
  ExchangeRateComponent,
  EternalLinkDialogComponent,
  IndicativeRateNoteComponent,
  LanguageSelectorComponent,
  MoneygramLocationsLinkComponent,
  PartnerWalletBannerComponent,
  StatusUpdatesComponent,
  TermsAndConditionsComponent,
  WalmartFootnoteComponent,
  MobilePhoneNumberComponent,
  DialogLocationMapComponent,
  AlertLocationComponent,
  PoweredByStellarComponent,
];

@NgModule({
  declarations: [SHARED_COMPONENTS],
  imports: [
    CommonModule,
    LocatorModule,
    DemoMaterialModule,
    MatBottomSheetModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [SHARED_COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [BaseComponent],
  // entryComponents: [
  //   CardCustomerSupportComponent,
  //   DialogComponent,
  //   EternalLinkDialogComponent,
  //   DialogLocationMapComponent,
  // ],
})
export class SharedModule {}
